module.exports = __webpack_public_path__ + "img/cp3-2.0a367e10.jpg";